import SearchModel from '../model/search'
import PostModel from '../model/posts'
import consts from '../consts/const';
export const SET_SEARCH = 'SET_SEARCH';
export const SET_SEARCHH = 'SET_SEARCHH';

export const set_search = (searchWord,page,limit) =>{
    return async dispatch => {
      if (!String(searchWord || '').trim()) return { longs: 0, shorts: 0 }
      const res= await fetch(`/api/search/${encodeURIComponent(searchWord)}/${page}/${limit}`);
       const data =[];
       const videos =[];
       const tages =[];
       const images = [];
       const communities = [];
       let ress = {};
       try {
         ress = await res.json();
       } catch (err) {
         ress = {};
       }
       for(const key in (ress.users || [])){
       data.push(new SearchModel(ress.users[key].id,ress.users[key].email,ress.users[key].img,ress.users[key].followNumb))
       }
       for(const key in (ress.communities || [])){
       communities.push(new SearchModel(ress.communities[key].id,ress.communities[key].name,ress.communities[key].img,ress.communities[key].memberCount))
       }
       for(const key in (ress.posts || [])){
       videos.push(new PostModel(ress.posts[key].id,ress.posts[key].image || ress.posts[key].content,ress.posts[key].title,ress.posts[key].type,ress.posts[key].userid,ress.posts[key].tages,ress.posts[key].disc,ress.posts[key].date,ress.posts[key].thumbnail,ress.posts[key].vCount,ress.posts[key].comm,ress.posts[key].pCount,ress.posts[key].dCount,ress.posts[key].userImg,ress.posts[key].email,ress.posts[key].userLink))
       }
       for(const key in (ress.tages || [])){
       tages.push(new PostModel(ress.tages[key].id,ress.tages[key].content,ress.tages[key].title,ress.tages[key].type,ress.tages[key].userid,ress.tages[key].tages,ress.tages[key].disc,ress.tages[key].date,ress.tages[key].thumbnail,ress.tages[key].vCount,ress.tages[key].comm,ress.tages[key].pCount,ress.tages[key].dCount,ress.tages[key].userImg,ress.tages[key].email,ress.tages[key].userLink))
       }
       for(const key in (ress.images || [])){
       images.push(new PostModel(ress.images[key].id,ress.images[key].content,ress.images[key].title,ress.images[key].type,ress.images[key].userid,ress.images[key].tages,ress.images[key].disc,ress.images[key].date,ress.images[key].thumbnail,ress.images[key].vCount,ress.images[key].comm,ress.images[key].pCount,ress.images[key].dCount,ress.images[key].userImg,ress.images[key].email,ress.images[key].userLink))
       }
    dispatch({type:SET_SEARCH,data:data,videos:videos,tages:tages,images:images,communities})
    return { longs: videos.length + images.length + data.length + communities.length, shorts: 0 }
  }
}
//   tages.push(new SearchModel(ress.tages[key].id,ress.tages[key].email,ress.tages[key].image,ress.tages[key].time))
export const set_searchh = (searchWord,page,limit) =>{
    return async dispatch => {
      if (!String(searchWord || '').trim()) return { longs: 0, shorts: 0 }
      const res= await fetch(`/api/search/${encodeURIComponent(searchWord)}/${page}/${limit}`);
       const data =[];
       const videos =[];
       const tages =[];
       const images = [];
       const communities = [];
       let ress = {};
       try {
         ress = await res.json();
       } catch (err) {
         ress = {};
       }
       for(const key in (ress.users || [])){
       data.push(new SearchModel(ress.users[key].id,ress.users[key].email,ress.users[key].img,ress.users[key].followNumb))
       }
       for(const key in (ress.communities || [])){
       communities.push(new SearchModel(ress.communities[key].id,ress.communities[key].name,ress.communities[key].img,ress.communities[key].memberCount))
       }
       for(const key in (ress.posts || [])){
       videos.push(new PostModel(ress.posts[key].id,ress.posts[key].image || ress.posts[key].content,ress.posts[key].title,ress.posts[key].type,ress.posts[key].userid,ress.posts[key].tages,ress.posts[key].disc,ress.posts[key].date,ress.posts[key].thumbnail))
       }
       for(const key in (ress.tages || [])){
       tages.push(new PostModel(ress.tages[key].id,ress.tages[key].content,ress.tages[key].title,ress.tages[key].type,ress.tages[key].userid,ress.tages[key].tages,ress.tages[key].disc,ress.tages[key].date,ress.tages[key].thumbnail))
       }
       for(const key in (ress.images || [])){
       images.push(new PostModel(ress.images[key].id,ress.images[key].content,ress.images[key].title,ress.images[key].type,ress.images[key].userid,ress.images[key].tages,ress.images[key].disc,ress.images[key].date,ress.images[key].thumbnail))
       }
    dispatch({type:SET_SEARCHH,data:data,videos:videos,tages:tages,images:images,communities})
    return { longs: videos.length + images.length + data.length + communities.length, shorts: 0 }
  }
}
